<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 14.4C19.52 14.4 19.2 14.08 19.2 13.6V7.20002C19.2 6.72002 19.52 6.40002 20 6.40002C20.48 6.40002 20.8 6.72002 20.8 7.20002V13.6C20.8 14.08 20.48 14.4 20 14.4Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M20 33.6C19.52 33.6 19.2 33.28 19.2 32.8V26.4C19.2 25.92 19.52 25.6 20 25.6C20.48 25.6 20.8 25.92 20.8 26.4V32.8C20.8 33.28 20.48 33.6 20 33.6Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M23.2 15.2C23.04 15.2 22.96 15.2 22.8 15.12C22.48 14.88 22.32 14.48 22.56 14.08L25.76 8.56002C26 8.24002 26.4 8.08002 26.8 8.32002C27.12 8.56002 27.28 8.96002 27.04 9.36002L23.84 14.88C23.68 15.04 23.44 15.2 23.2 15.2Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M13.6 31.84C13.44 31.84 13.36 31.84 13.2 31.76C12.88 31.52 12.72 31.12 12.96 30.72L16.16 25.2C16.4 24.88 16.8 24.72 17.2 24.96C17.52 25.2 17.68 25.6 17.44 26L14.24 31.52C14.08 31.68 13.84 31.84 13.6 31.84Z"
      :fill="color"
    />
    <path
      opacity="0.93"
      d="M16.8 15.2C16.56 15.2 16.32 15.04 16.16 14.8L12.96 9.28001C12.72 8.96001 12.88 8.48001 13.2 8.24001C13.52 8.00001 14 8.16001 14.24 8.48001L17.44 14C17.68 14.32 17.52 14.8 17.2 15.04C17.04 15.2 16.96 15.2 16.8 15.2Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M26.4 31.84C26.16 31.84 25.92 31.68 25.76 31.44L22.56 25.92C22.32 25.6 22.48 25.12 22.8 24.88C23.12 24.64 23.6 24.8 23.84 25.12L27.04 30.64C27.28 30.96 27.12 31.44 26.8 31.68C26.64 31.76 26.56 31.84 26.4 31.84Z"
      :fill="color"
    />
    <path
      opacity="0.65"
      d="M13.6 20.8H7.20002C6.72002 20.8 6.40002 20.48 6.40002 20C6.40002 19.52 6.72002 19.2 7.20002 19.2H13.6C14.08 19.2 14.4 19.52 14.4 20C14.4 20.48 14.08 20.8 13.6 20.8Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M32.8 20.8H26.4C25.92 20.8 25.6 20.48 25.6 20C25.6 19.52 25.92 19.2 26.4 19.2H32.8C33.28 19.2 33.6 19.52 33.6 20C33.6 20.48 33.28 20.8 32.8 20.8Z"
      :fill="color"
    />
    <path
      opacity="0.86"
      d="M14.48 17.52C14.32 17.52 14.24 17.52 14.08 17.44L8.56002 14.24C8.24002 14 8.08002 13.6 8.32002 13.2C8.56002 12.88 8.96002 12.72 9.36002 12.96L14.88 16.16C15.2 16.4 15.36 16.8 15.12 17.2C14.96 17.44 14.72 17.52 14.48 17.52Z"
      :fill="color"
    />
    <path
      opacity="0.3"
      d="M31.12 27.12C30.96 27.12 30.88 27.12 30.72 27.04L25.2 23.84C24.88 23.6 24.72 23.2 24.96 22.8C25.2 22.48 25.6 22.32 26 22.56L31.52 25.76C31.84 26 32 26.4 31.76 26.8C31.6 27.04 31.36 27.12 31.12 27.12Z"
      :fill="color"
    />
    <path
      opacity="0.44"
      d="M8.87995 27.12C8.63995 27.12 8.39995 26.96 8.23995 26.72C7.99995 26.4 8.15995 25.92 8.47995 25.68L13.9999 22.48C14.3199 22.24 14.7999 22.4 15.0399 22.72C15.2799 23.04 15.1199 23.52 14.7999 23.76L9.27995 26.96C9.19995 27.12 9.03995 27.12 8.87995 27.12Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SpinnerIcon',
  props: {
    color: {
      type: String,
      default: '#FFFFFF',
    },
  },
}
</script>

<style>
/* Default rotation animation */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Default animation class */
.spinner-icon-animate {
  animation: spin 1s linear infinite;
}

/* Slower animation variant */
.spinner-icon-slow {
  animation: spin 1.5s linear infinite;
}
</style>
